import React from 'react';
import { createStyles, Dialog, DialogContent, DialogTitle, withStyles } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
import WorkShiftManagementForm from './index';
const styles = ({ palette, spacing }) => createStyles({
    container: {
        width: 600
    },
    title: {
        color: palette.text.color,
        '& h2': {
            color: 'inherit'
        }
    },
    containerContent: {
        paddingBottom: spacing(3),
        height: 450
    }
});
function WorkShiftManagementFormInDialog({ classes, isOpen, onClose, ...formProps }) {
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, PaperProps: {
            className: classes.container
        } },
        React.createElement(DialogTitle, { className: classes.title }, I18n.t('RegisterJob')),
        React.createElement(DialogContent, { className: classes.containerContent },
            React.createElement(WorkShiftManagementForm, { ...formProps }))));
}
export default withStyles(styles)(WorkShiftManagementFormInDialog);
